var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.281,
    height: 22.45,
    viewBox: "0 0 22.281 22.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(-1114.871 -224.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M1115.2,230.763c.034-1.164.07-2.328.1-3.492a2.478,2.478,0,0,1,2.459-2.456c2.226-.058,4.453-.107,6.679-.184a2.9,2.9,0,0,1,2.28.922q4.645,4.694,9.32,9.359a2.464,2.464,0,0,1,.617,2.857,2.884,2.884,0,0,1-.585.838q-3.5,3.54-7.029,7.056a2.467,2.467,0,0,1-3.629-.011q-4.757-4.755-9.5-9.521a2.626,2.626,0,0,1-.794-1.967c.011-1.133,0-2.268,0-3.4Zm1.089.02h-.169c0,1.113.005,2.227,0,3.34a1.745,1.745,0,0,0,.513,1.314q4.744,4.751,9.483,9.5a1.485,1.485,0,0,0,2.237,0q3.523-3.518,7.033-7.053a1.484,1.484,0,0,0,0-2.216q-4.755-4.782-9.52-9.553a1.581,1.581,0,0,0-1.2-.483c-2.257.053-4.515.106-6.77.175a1.489,1.489,0,0,0-1.6,1.633C1116.279,228.556,1116.293,229.669,1116.293,230.783Z",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M1119.244,231.159a2.375,2.375,0,0,1,2.375-2.4,2.4,2.4,0,1,1-2.375,2.4Zm2.386,1.39a1.383,1.383,0,0,0,1.392-1.408,1.394,1.394,0,1,0-2.788.031A1.388,1.388,0,0,0,1121.63,232.549Z",
    fill: "#7e97b8",
    stroke: "#7e97b8",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.23e6f28d56d477e3b974735e9bda361b.svg";
export { ForwardRef as ReactComponent };